<template>
  <Dialog v-model:visible="visible" :closable="false" modal header="" class="update-modal" :style="{ width: '450px' }"
    :breakpoints="{ '960px': '80vw' }">
    <div class="fluid text-center">
      <img alt="logo" src="assets/layout/images/logo_kron_tm128.png" width="52" to="/" />
      <h3 class="mt-2 mb-2">Требуется обновление</h3>
      <p class="mt-0 mb-4">
        Клиент обновился, требуется перезагрузка страницы.
      </p>
      <Button label="Обновить" icon="pi pi-sync" @click="reloadPage" :autoFocus="true" />
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const reloadPage = () => {
  window.location.reload();
};
</script>

<style scoped>
.update-modal :deep(.p-dialog-header) {
  display: none;
}

.update-modal :deep(.p-dialog-content) {
  padding: 1.5rem !important;
}
</style>